import React from "react";
import { ThreeDots } from "react-loader-spinner";

export default function Loader({ small }) {
	return (
		<div className="d-flex justify-content-center align-items-center" style={{ padding: small ? 12 : 60 }}>
			<ThreeDots height={small ? 24 : 50} width={small ? 24 : 50} color="#4c6b0d" />
		</div>
	);
}
